export const creationData = [
    {
        id: 1,
        name: "DEEP EARTH",
        image: require("../images/desktop/image-deep-earth.jpg")
    },
    {
        id: 2,
        name: "NIGHT ARCADE",
        image: require("../images/desktop/image-night-arcade.jpg")
    },
    {
        id: 3,
        name: "SOCCER TEAM VR",
        image: require("../images/desktop/image-soccer-team.jpg")
    },
    {
        id: 4,
        name: "THE GRID",
        image: require("../images/desktop/image-grid.jpg")
    },
    {
        id: 5,
        name: "FROM UP ABOVE VR",
        image: require("../images/desktop/image-from-above.jpg")
    },
    {
        id: 6,
        name: "POCKET BOREALIS",
        image: require("../images/desktop/image-pocket-borealis.jpg")
    },
    {
        id: 7,
        name: "THE CURIOSITY",
        image: require("../images/desktop/image-curiosity.jpg")
    },
    {
        id: 8,
        name: "THE CURIOSITY",
        image: require("../images/desktop/image-fisheye.jpg")
    }
]